(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState;
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.isStarted = false;
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "move",
            value: function move(state) {
                var _this = this;
                var newState = state.map(function(row) {
                    var rowWithoutZeros = row.filter(function(n) {
                        return n !== 0;
                    });
                    for(var i = 1; i < rowWithoutZeros.length; i++)if (rowWithoutZeros[i] === rowWithoutZeros[i - 1]) {
                        rowWithoutZeros[i - 1] = rowWithoutZeros[i - 1] * 2;
                        rowWithoutZeros[i] = 0;
                        _this.score += rowWithoutZeros[i - 1];
                        i++;
                    }
                    var compacted = rowWithoutZeros.filter(function(n) {
                        return n !== 0;
                    });
                    while(compacted.length <= 3)compacted.push(0);
                    return compacted;
                });
                return newState;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (!this.isStarted) return;
                var newState = this.move(this.state);
                if (!this.checkState(this.state, newState)) {
                    var updateState = this.setCell(newState);
                    this.isWinner(updateState);
                    if (this.isLoser(updateState) === false) this.status = "lose";
                    return updateState;
                }
                return newState;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (!this.isStarted) return;
                var state = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                state.map(function(row) {
                    return row.reverse();
                });
                var newState = this.move(state).map(function(row) {
                    return row.reverse();
                });
                if (!this.checkState(this.state, newState)) {
                    var updateState = this.setCell(newState);
                    this.isWinner(updateState);
                    if (this.isLoser(updateState) === false) this.status = "lose";
                    return updateState;
                }
                return newState;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (!this.isStarted) return;
                var state = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                var transposedState = this.transpose(state, "up");
                var newState = this.transpose(this.move(transposedState), "up");
                if (!this.checkState(this.state, newState)) {
                    var updateState = this.setCell(newState);
                    this.isWinner(updateState);
                    if (this.isLoser(updateState) === false) this.status = "lose";
                    return updateState;
                }
                return newState;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (!this.isStarted) return;
                var state = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                var transposedState = this.transpose(state).map(function(row) {
                    return row.reverse();
                });
                var newState = this.transpose(this.move(transposedState).map(function(row) {
                    return row.reverse();
                }));
                if (!this.checkState(this.state, newState)) {
                    var updateState = this.setCell(newState);
                    this.isWinner(updateState);
                    if (this.isLoser(updateState) === false) this.status = "lose";
                    return updateState;
                }
                return newState;
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.isStarted = true;
                this.status = "playing";
                for(var i = 0; i < 2; i++)this.setCell();
                return this.state;
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "excludedIndex",
            value: function excludedIndex() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var excludedIndex = [];
                this.state.forEach(function(row, rowIndex) {
                    row.forEach(function(cell, colIndex) {
                        if (cell !== 0) excludedIndex.push(rowIndex * 4 + colIndex);
                    });
                });
                if (index !== false) excludedIndex.push(index);
                return excludedIndex;
            }
        },
        {
            key: "setCell",
            value: function setCell() {
                var _this = this;
                var newState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                if (newState) this.state = newState;
                var emptyCells = Array.from({
                    length: 16
                }, function(_, i) {
                    return i;
                }).filter(function(i) {
                    return !_this.excludedIndex().includes(i);
                });
                if (!emptyCells.length) return this.state;
                var randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
                var row = Math.floor(randomCell / 4);
                var col = randomCell % 4;
                this.state[row][col] = Math.random() < 0.9 ? 2 : 4;
                return this.state;
            }
        },
        {
            key: "checkState",
            value: function checkState(oldState, newState) {
                return oldState.every(function(row, i) {
                    return row.length === newState[i].length && row.every(function(num, j) {
                        return num === newState[i][j];
                    });
                });
            }
        },
        {
            key: "transpose",
            value: function transpose(state) {
                var result = [];
                for(var col = 0; col < state.length; col++){
                    result[col] = [];
                    for(var row = 0; row < state[col].length; row++)result[col].push(state[row][col]);
                }
                return result;
            }
        },
        {
            key: "isWinner",
            value: function isWinner() {
                if (this.state.flat().includes(2048)) this.status = "win";
            }
        },
        {
            key: "isLoser",
            value: function isLoser() {
                var canMove = false;
                var hasEmptyCells = false;
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (this.state[r][c] === 0) hasEmptyCells = true;
                    if (r < 3 && this.state[r][c] === this.state[r + 1][c] || c < 3 && this.state[r][c] === this.state[r][c + 1]) canMove = true;
                }
                if (!canMove && !hasEmptyCells) this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$gameRows = document.querySelectorAll(".field-row");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
// Write your code here
$197cd56b15c33885$var$button.addEventListener("click", function(e) {
    if ($197cd56b15c33885$var$button.classList.contains("restart")) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$game.start();
    } else $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$button.classList.remove("start");
    $197cd56b15c33885$var$button.classList.add("restart");
    $197cd56b15c33885$var$msgStart.classList.add("hidden");
    $197cd56b15c33885$var$msgWin.classList.add("hidden");
    $197cd56b15c33885$var$msgLose.classList.add("hidden");
    $197cd56b15c33885$var$button.textContent = "Restart";
    $197cd56b15c33885$var$updateStat($197cd56b15c33885$var$game.getState());
});
document.addEventListener("keydown", function(e) {
    e.preventDefault();
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$updateStat($197cd56b15c33885$var$game.state);
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$msgWin.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$msgLose.classList.remove("hidden");
});
function $197cd56b15c33885$var$updateStat(state) {
    for(var i = 0; i < 4; i++){
        var cells = $197cd56b15c33885$var$gameRows[i].querySelectorAll(".field-cell");
        for(var k = 0; k < 4; k++){
            var value = state[i][k];
            cells[k].className = "field-cell";
            if (value === 0) cells[k].textContent = "";
            else {
                cells[k].textContent = value;
                cells[k].classList.add("field-cell--" + value);
            }
        }
    }
}

})();
//# sourceMappingURL=index.285d39df.js.map
